/**
 * Organizations
 */
import React from 'react';
import { Header, ItemDescription, Loader } from 'semantic-ui-react';
// @ts-ignore
import { ErrorBoundary } from '../../workspaces/redux-error-boundary';

// Components
// @ts-ignore
import ErrorBoundaryAlert from '../../components/ErrorBoundaryAlert';
import PageWrapper from '../../components/PageWrapper';
import LoadingGate from '../../components/LoadingGate';
import ErrorGate from '../../components/ErrorGate';
// @ts-ignore
import OrganizationsRequest from '../../components/OrganizationsRequest';
import OrganizationsList from './components/OrganizationsList';
import ImportPeopleLinkButton from './components/ImportPeopleModal/components/ImportPeopleLinkButton';
import ImportPeopleModal from './components/ImportPeopleModal';
import NewOrganizationLinkButton from './components/NewOrganizationModal/components/NewOrganizationLinkButton';
import NewOrganizationModal from './components/NewOrganizationModal';

export default function Organizations(): React.ReactElement {
    return (
        <ErrorBoundary
            namespace="Organizations"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <OrganizationsRequest />
            <PageWrapper>
                <ErrorGate namespace="ORGANIZATIONS_LOAD">
                    <LoadingGate
                        namespace="ORGANIZATIONS_LOAD"
                        LoadingComponent={<Loader active inline="centered" />}
                    >
                        <Header as="h2" textAlign="center">
                            Organizations
                        </Header>

                        <div
                            style={{
                                textAlign: 'center',
                                marginBottom: '20px'
                            }}
                        >
                            <NewOrganizationLinkButton />
                        </div>
                        <div
                            style={{
                                textAlign: 'center',
                                marginBottom: '20px'
                            }}
                        >
                            <ImportPeopleLinkButton />
                        </div>
                        <ImportPeopleModal />
                        <NewOrganizationModal />
                        <OrganizationsList />
                    </LoadingGate>
                </ErrorGate>
            </PageWrapper>
        </ErrorBoundary>
    );
}
